<template>
    <div class="page-content" >
      <div class="header">
        <img src="../../static/back.png" style="width: 100%"/>
      </div>
      <div class="title-content">
        <h1 style="text-align: center">项 目 介 绍</h1>
      </div>
      <div class="card-container">
        <a-row >
          <a-col :span="6" v-for="(item,index) of data" :key="index" align="center" >
              <a-card hoverable style="width: 260px;margin-top: 20px;" @click="handleClick(item.link)" >
                <div style="height: 240px">
                  <img
                    alt="example"
                    :src="item.imgUrl"
                    slot="cover"
                    style="width: 100%"
                  />
                </div>
                <a-card-meta :title="item.title" style=" width: 200px;overflow: hidden;text-overflow:ellipsis;white-space: nowrap;">
                  <template slot="description" >{{item.description}}</template>
                </a-card-meta>
              </a-card>
          </a-col>
        </a-row>
        <a-row >
          <a-col>
              <div style="width:260px;margin-top: 20px;margin-left:45%;height:20px;">
                <a target="_blank" href="http://beian.miit.gov.cn" style="display:inline-block;text-decoration:none;height:20px;line-height:20px;color:black;">
                  苏ICP备2021055271号</a>
              </div>
          </a-col>
        </a-row>
      </div>

    </div>
</template>

<script>
    import AFormItem from "ant-design-vue/es/form/FormItem";
    import ARow from "ant-design-vue/es/grid/Row";
    import ACol from "ant-design-vue/es/grid/Col";
    export default {
      name: "Homepage",
      components: {ACol, ARow, AFormItem},
      data(){
          return {
            img:[],
            data:[],
          }
      },
      created (){
        this.getCaseData();
      },
      methods:{
        getCaseData(){
          let url= '/vl/api/IndexShowController/getAll';
          this.axios.get(url).then((res)=>{
            this.data = res.data.data.list
          }).catch((error)=>{
            this.$notification['error']({
              message:'请重试'
            })
          })
        },
        handleClick (url){
          if (url){
            window.open(url);
          }else {
            this.$notification['error']({
              message:'链接地址错误，请联系管理员'
            })
          }
        }
      }
    }
</script>

<style scoped>
  .page-content{
    width: 100%;
    display: flex;
    flex-direction:column;
    align-items: center;
    /*justify-content:center;*/
  }
  .header{
    /*background: url("../../static/back.png");*/
    min-width: 100px;
    background-size:100% auto;
    width: 100%;
  }
  .title-content{
    min-width: 800px;
    height: 10%;
    margin-top: 20px;
  }
  .card-container{
    /*display: flex;*/
    /*flex-direction: row;*/
    /*height: 50%;*/
    width: 80%;
    /*align-items: start;*/
    /*justify-content:space-around;*/
    /*margin-top: 15px;*/
    /*flex-wrap:wrap;*/
  }
</style>



// WEBPACK FOOTER //
// src/pages/HomePage.vue